import React from "react";

import { Stack, styled, Typography } from "@mui/material";
import { ReactComponent as BinIcon } from "assets/icons/bin.svg";
import { useFormatDateHook } from "hooks";
import { useDealFormUserSelect, useUserIdSelector } from "store";
import { IFile, IUser } from "store/types";

import { ReactComponent as DownloadIcon } from "../../../assets/icons/download-sharp.svg";
import { useFilePreviewHooks } from "../../old-data-box-components/File-preview/use-file-preview-hooks";
import { FileViewer } from "../../popups/Viewer/FileViewer";

export interface FilePreviewLightProps {
  file: IFile;
  className?: string;
}

const StyledText = styled(Typography)(() => ({
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
  fontSize: "15px",
  color: "#173c4c"
}));

export const FilePreviewLight: React.FC<FilePreviewLightProps> = ({ file }) => {
  const { onDelete, onDownload, isOpen, setIsOpen } = useFilePreviewHooks(file);
  const userId: number | undefined = useUserIdSelector();
  const user: Partial<IUser> | undefined = useDealFormUserSelect(file.user_id);
  const formatDate = useFormatDateHook();

  const actionHandler = () => {
    if (file.type === "png" || file.type === "jpeg" || file.type === "jpg" || file.type === "pdf") {
      setIsOpen(true);
    } else onDownload();
  };

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <Stack
      sx={{
        flexDirection: "row",
        p: "6px",
        fontSize: "15px",
        cursor: "pointer",
        borderRadius: "8px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        gap: "10px",
        ".opacity-icon": { opacity: 0, transition: "opacity 0.3s linear" },
        ":hover": { bgcolor: "#edf1f9", ".opacity-icon": { opacity: 1 } }
      }}
    >
      <Stack
        sx={{
          flexDirection: "row",
          overflow: "hidden",
          gap: "5px"
        }}
      >
        <StyledText sx={{ maxWidth: "30%" }} onClick={actionHandler}>
          {`${file.name}`}{" "}
        </StyledText>
        <StyledText sx={{ maxWidth: "35%" }}>{`published by: ${user?.full_name}`}</StyledText>
        <StyledText sx={{ maxWidth: "30%" }}>
          on: {formatDate({ date: file.created_at, format: "HH:mm, MMM DD, YYYY" })}
        </StyledText>
      </Stack>
      {file.state === "scanning" ? (
        <Typography>scanning</Typography>
      ) : (
        <Stack sx={{ flexDirection: "row", gap: "12px" }}>
          {userId === file.user_id && <BinIcon className="opacity-icon" width={18} height={18} onClick={onDelete} />}
          <DownloadIcon className="opacity-icon" onClick={onDownload} width={18} height={18} />
        </Stack>
      )}
      <FileViewer file={file} isOpen={isOpen} onClose={onClose} />
    </Stack>
  );
};
